import { Lightning } from '@lightningjs/sdk';
import { Theme } from '../../config/theme';

const _constants = {
  textLeftMargin: 40,
  textBottomMargin: 20,
  textMaxHeight: 140,
  cornerRadius: 8,
};

export class CmsBannerImage extends Lightning.Component {
  static _template() {
    return {
      Background: {
        x: 0,
        y: 0,
        w: w => w,
        h: h => h,
        rect: true,
        color: Theme.Colors.Ribbon.Card.Background,
      },
      Image: {
        x: 0,
        y: 0,
        w: w => w,
        h: h => h,
      },
      TextBackground: {
        mountY: 1,
        x: _constants.cornerRadius / 2,
        y: h => h - _constants.cornerRadius / 2,
        w: w => w * 0.6,
        h: h => Math.min(h * 0.6, _constants.textMaxHeight) + _constants.textBottomMargin * 3,
        rect: true,
        color: Theme.Colors.Transparent,
        shader: {
          type: Lightning.shaders.RadialGradient,
          innerColor: 0xbb000000,
          outerColor: Theme.Colors.Transparent,
        },
      },
      TextContainer: {
        // w: w => w * 0.6,
        // h: h => Math.min(h * 0.5, _constants.textMaxHeight),
        mountY: 1,
        x: _constants.textLeftMargin,
        y: h => h - _constants.textBottomMargin,
        flex: {
          direction: 'column',
          justifyContent: 'flex-end',
        },
        Line1: {
          x: 0,
          y: 0,
          text: {
            ...Theme.Fonts.Banner.Line1,
            textAlign: 'left',
            text: '',
          },
        },
        Line2: {
          x: 0,
          y: 0,
          text: {
            ...Theme.Fonts.Banner.Line2,
            textAlign: 'left',
            text: '',
          },
        },
        Line3: {
          x: 0,
          y: 0,
          text: {
            ...Theme.Fonts.Banner.Line3,
            textAlign: 'left',
            text: '',
          },
        },
      },
    };
  }

  _init() {
    this.tag('Image').src = this.imageUrl;
    if (this.banner.overlay) {
      this.initText();
    } else {
      this.disableText();
    }
  }

  _firstActive() {
    if (this.banner.overlay) {
      if (!this.banner.overlay.line1 || !this.banner.overlay.line3 || !this.banner.overlay.line2) {
        this.tag('TextBackground').h = this.tag('TextBackground').finalH - 30; // make shadow smaller if there are lines missing
      }
    }
  }

  _active() {
    this.tag('TextBackground').shader.radiusX = this.tag('TextBackground').finalW * 0.5;
    this.tag('TextBackground').shader.radiusY = this.tag('TextBackground').finalH * 0.5;
    // move shader to left bottom corner
    this.tag('TextBackground').shader.y = this.tag('TextBackground').finalH;
  }

  initText() {
    if (this.banner.overlay.line1) {
      this.tag('Line1').text.text = this.banner.overlay.line1;
    } else {
      this.tag('Line1').visible = false;
    }
    if (this.banner.overlay.line2) {
      this.tag('Line2').text.text = this.banner.overlay.line2;
    } else {
      this.tag('Line2').visible = false;
    }
    if (this.banner.overlay.line3) {
      this.tag('Line3').text.text = this.banner.overlay.line3;
    } else {
      this.tag('Line3').visible = false;
    }
  }

  disableText() {
    this.tag('TextContainer').visible = false;
    this.tag('TextBackground').visible = false;
  }
}
